<template>
  <default-layout class-list="order-list-holder">
    <vue-headful
      v-if="project && project.name"
      :title="`${project.name} | ${unitsTitle}`"
    />
    <UnitList v-if="!loading"/>
    <circle-spin
      v-else
      :loading="loading"
      class="turquoise--text"
      height="250"
      width="250"
    />
  </default-layout>
</template>

<script>
import store from '@/store';
import DefaultLayout from '@/layouts/Default.vue';
import UnitList from '@/components/UnitList.vue';
import { mapGetters, mapState } from 'vuex';
import VueHeadful from 'vue-headful';

export default {
  name: 'UnitListView',
  components: {
    DefaultLayout,
    UnitList,
    VueHeadful,
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapGetters('project', [
      'agents',
      'brokerCompany',
      'contactsModules',
      'settings',
      'project',
      'pages',
    ]),
    ...mapState(['units']),
    unitsTitle() {
      const pages = this.pages || [];
      const page = pages.find(p => p && p.route === 'unit-list');
      if (page && page.label) {
        return this.$t ? this.$t(page.label) : page.label;
      }
      return this.$t ? this.$t('Units') : 'Units';
    },
  },
  beforeMount() {
    const init = true;
    const { iso: lang } = this.$store.getters['project/languageDefault'];
    const { params: { order } } = this.$route;

    Promise
      .all([
        store.dispatch('units/init', { lang, init, order }),
        store.dispatch('unitTypes/init', { lang, init, order }),
      ])
      .finally(() => this.loading = false)
  },
};
</script>

<style>
.order-list-holder {
  background: #eee;
}
</style>
